import { axios } from '@/utils';

export const getShifts =  (userId: string) => async () => {
  const response = await axios.get(`/shift/user/${userId}`);

  return response.data.data;
};
